// 视图迁移：直接使用remove会导致点击事件丢失
export const removeChildWithoutDestory = (childNode) => {
  const $destory = childNode.$destory;
  childNode.$destory = null;
  childNode.remove();
  childNode.$destory = $destory;
};

export const containerHasChild = (container: any, child: any) => {
  if (!container || !container?.childNodes || !child) {
    return false;
  }
  let has = false;
  for (const key in container.childNodes) {
    if (Object.prototype.hasOwnProperty.call(container.childNodes, key)) {
      const element = container.childNodes[key];
      if (element === child) {
        has = true;
        break;
      }
    }
  }
  // console.log('container has childNodes:', has);
  return has;
};
